module.exports = __webpack_public_path__ + "static/media/saneamentoLiminar_.0cdc53f8.png";